import type { CenterTab } from '../../types';
import { useDeal } from '../../hooks/useDeal';

interface Props {
  dealId: string;
  activeTab: CenterTab;
  onChangeTab: (t: CenterTab) => void;
}

export function CenterTabs({ dealId, activeTab, onChangeTab }: Props) {
  const { data } = useDeal(dealId);
  const recentActivity = data.activity.slice(0, 1)[0];
  const showPulse = recentActivity && (Date.now() - new Date(recentActivity.occurredAt).getTime() < 60_000 * 30);

  const t = (k: CenterTab) => activeTab === k ? 'center-tab active' : 'center-tab';
  return (
    <div className="center-tabs">
      <button className={t('overview')}     onClick={() => onChangeTab('overview')}>Overview</button>
      <button className={t('title')}        onClick={() => onChangeTab('title')}>
        Title <span className="count">{data.findings.length}</span>
      </button>
      <button className={t('comps')}        onClick={() => onChangeTab('comps')}>
        Comps <span className="count">{data.comps.length}</span>
      </button>
      <button className={t('package')}      onClick={() => onChangeTab('package')}>
        Package {data.packageDraft && <span className="count">v{data.packageDraft.version}</span>}
      </button>
      <button className={t('activity')}     onClick={() => onChangeTab('activity')}>
        Activity {showPulse && <span className="pulse-dot" />}
      </button>
    </div>
  );
}
